import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    scroll-behavior: smooth;
  }

  body {
    font-family: ${({ theme }) => theme.fonts.body};
    background: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text};
    line-height: 1.5;
    direction: rtl;
    min-height: 100vh;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${({ theme }) => theme.fonts.heading};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    line-height: 1.3;
    margin-bottom: 0.5em;
    color: ${({ theme }) => theme.colors.text};
    letter-spacing: -0.01em;
  }

  h1 { font-size: 2rem; }
  h2 { font-size: 1.5rem; }
  h3 { font-size: 1.25rem; }
  h4 { font-size: 1.125rem; }

  p {
    margin-bottom: 1em;
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
    transition: color ${({ theme }) => theme.transitions.fast};
  }

  a:hover {
    color: ${({ theme }) => theme.colors.primaryDark};
    text-decoration: underline;
  }

  /* Tables: direction and alignment follow document language (RTL/LTR) */
  [dir="rtl"] table th,
  [dir="rtl"] table td {
    direction: rtl;
    text-align: right;
    vertical-align: middle;
  }
  [dir="ltr"] table th,
  [dir="ltr"] table td {
    direction: ltr;
    text-align: left;
    vertical-align: middle;
  }

  /* Custom scrollbar - Cosmic Dark */
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #0a0a0f; 
    border-left: 1px solid rgba(255, 255, 255, 0.05);
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 5px;
    border: 2px solid #0a0a0f; /* Creates padding effect */
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgba(74, 158, 255, 0.4);
  }

  /* Selection */
  ::selection {
    background: ${({ theme }) => theme.colors.accentLight};
    color: ${({ theme }) => theme.colors.primary};
  }

  /* Animations */
  @keyframes spin {
    to { transform: rotate(360deg); }
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes slideUp {
    from { 
      opacity: 0;
      transform: translateY(16px);
    }
    to { 
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes scaleIn {
    from { 
      opacity: 0;
      transform: scale(0.95);
    }
    to { 
      opacity: 1;
      transform: scale(1);
    }
  }

  /* Ultra plan chip: rotating gradient border + glow (requires Houdini @property) */
  @property --ultra-border-angle {
    syntax: "<angle>";
    initial-value: 0deg;
    inherits: false;
  }
  @keyframes ultra-border-spin {
    to { --ultra-border-angle: 360deg; }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    html {
      font-size: 15px;
    }
  }
`;

export default GlobalStyles;
